export const ActionTypes = {
  CLEAR_DISPENSER_USER: "CLEAR_DISPENSER_USER",
  OPEN_DISPENSER_USER_SNACK: "OPEN_DISPENSER_USER_SNACK",
  CLOSE_DISPENSER_USER_SNACK: "CLOSE_DISPENSER_USER_SNACK",
  GET_DRIVER_USER: "GET_DRIVER_USER",
  GET_DISPENSER_USER: "GET_DISPENSER_USER",
  SET_DISPENSER_USER_FILTERS: "SET_DISPENSER_USER_FILTERS",
  DISPENSER_USER_SELECTED: "DISPENSER_USER_SELECTED",
  RESET_DISPENSER_USER_SELECTED: "RESET_DISPENSER_USER_SELECTED",
  CREATE_DISPENSER_USER: "CREATE_DISPENSER_USER",
  
  SET_CONFIG_PAGE_DISPENSER_USER: "SET_CONFIG_PAGE_DISPENSER_USER",
  SET_CONFIG_PAGE_SIZE_DISPENSER_USER: "SET_CONFIG_PAGE_SIZE_DISPENSER_USER",
  SET_CONFIG_FILTER_DISPENSER_USER: "SET_CONFIG_FILTER_DISPENSER_USER",
  SET_CONFIG_SORTED_DISPENSER_USER: "SET_CONFIG_SORTED_DISPENSER_USER",
};
